import p from "./ghl-ui.es1204.js";
import h from "./ghl-ui.es1205.js";
import r from "./ghl-ui.es1206.js";
function e(t) {
  var o = -1, a = t == null ? 0 : t.length;
  for (this.__data__ = new p(); ++o < a; )
    this.add(t[o]);
}
e.prototype.add = e.prototype.push = h;
e.prototype.has = r;
export {
  e as default
};
